import React from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'
import _get from 'lodash/get'

export const IMAGE_TYPE_WEBP = 'image/webp'
export const IMAGE_TYPE_JPG = 'image/jpeg'
export const IMAGE_TYPE_PNG = 'image/png'
export const IMAGE_TYPE_SVG = 'image/svg+xml'

export const IMAGE_LOADING_LAZY = 'lazy'
export const IMAGE_LOADING_EAGER = 'eager'

function getClassName (props) {
  const { className } = props
  const baseClassName = 'picture'
  const baseClassNameArray = [baseClassName]

  if (className) {
    baseClassNameArray.push(className)
  }

  return baseClassNameArray.join(' ')
}

function getImageClassName (props) {
  const { imageClassName } = props
  const baseClassName = 'picture__image'
  const baseClassNameArray = [baseClassName]

  if (imageClassName) {
    baseClassNameArray.push(imageClassName)
  }

  return baseClassNameArray.join(' ')
}

const Picture = (props) => {
  const {
    fallbackSrc,
    height,
    width,
    alt,
    loading,
    sources,
  } = props

  return (
    <picture className={getClassName(props)}>
      {_map(sources, (source, index) => (
        <source
          key={index}
          srcSet={_get(source, 'srcSet')}
          media={_get(source, 'media')}
          type={_get(source, 'type')}
          width={width}
          height={height}
        />
      ))}
      <img
        className={getImageClassName(props)}
        src={fallbackSrc}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
      />
    </picture>
  )
}

Picture.propTypes = {
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  fallbackSrc: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  alt: PropTypes.string.isRequired,
  loading: PropTypes.string,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      srcSet: PropTypes.string.isRequired,
      media: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
}

export default Picture
